// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"d38f8858","170":"f708a818","244":"d7f6dae9","664":"cb577a0c"}[chunkId] + ".chunk.js";
};